import { FC, useEffect } from 'react';
import { i18n } from './index';
import { resolveAnonymousLocale, resolveAuthenticatedLocale } from './localeResolver';

interface LocaleSyncProps {
  user: { user?: { id?: string; locale?: unknown } };
}

const LocaleSync: FC<LocaleSyncProps> = ({ user }) => {
  const authenticatedUser = user?.user;
  const hasAuthenticatedIdentity = Boolean(authenticatedUser?.id);

  useEffect(() => {
    const updateDocumentLanguage = (locale: string) => {
      if (typeof document !== 'undefined') {
        document.documentElement.lang = locale;
      }
    };

    updateDocumentLanguage(i18n.language);
    i18n.on('languageChanged', updateDocumentLanguage);

    return () => {
      i18n.off('languageChanged', updateDocumentLanguage);
    };
  }, []);

  useEffect(() => {
    const locale = hasAuthenticatedIdentity
      ? resolveAuthenticatedLocale(authenticatedUser?.locale)
      : resolveAnonymousLocale().locale;

    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }

  }, [authenticatedUser, hasAuthenticatedIdentity]);

  return null;
};

export default LocaleSync;
